import { WixDesignSystemProvider } from '@wix/design-system';
import React, { PropsWithChildren } from 'react';

import '@wix/design-system/styles.global.css';
import 'styles/global.scss';

export const DesignContextProvider = ({ children }: PropsWithChildren) => {
  return <WixDesignSystemProvider features={{ newColorsBranding: true }}>{children}</WixDesignSystemProvider>;
};
